// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-group__items[data-v-1f580f2a] {\n  padding-left: 16px;\n}\n.list-group__loader[data-v-1f580f2a] .loader-icon {\n  font-size: 22px;\n}\n.list .list-group + .list-group[data-v-1f580f2a] {\n  margin-top: -1px;\n}\n.list .list-group + .list-group[data-fake][data-v-1f580f2a] {\n  margin-top: 15px;\n}\n.list .list-item[data-v-1f580f2a] {\n  margin-top: -1px;\n}\n", ""]);
// Exports
module.exports = exports;
